import { DataRawType, DataType, Language } from "../types/common";

export class GlobalConstants {
  static CONFIRMATION_DIALOG_DEFAULTS = {
    okBtnText: 'Confirmar',
    cancelBtnText: 'Cancelar',
  };
}

export const selectedLanguage = Language.PT_PT;

export const ACCEPTED_NON_AUTH_ROUTES = ['login', 'logout', 'activate'];

export const DataTypeToRawTypeMap = {
  [DataType.TEXT]: DataRawType.TEXT,
  [DataType.DATE]: DataRawType.TEXT,
  [DataType.LIST]: DataRawType.TEXT,
  [DataType.BOOLEAN]: DataRawType.BOOLEAN,
  [DataType.NUMBER]: DataRawType.NUMBER,
  [DataType.IMAGE]: DataRawType.TEXT,
};

export const VARIABLE_PLACEHOLDER_REGEX = /{([^{}]+)}/g;
